import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import React, { useState, useEffect } from 'react';
import Tab from '../components/tab';
import { motion } from "framer-motion";
import { Typewriter } from "react-simple-typewriter";
import Footer from "../components/Footer";
import {
  returnHome,
  currentExperience,
} from "../../../Redux/ActionCreator";
import { useSelector, useDispatch } from "react-redux";
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";
import { saveIntoServerCache, getOneFromServerCache } from "../../../utils/saveIntoCache";
import { capitalize } from "../../../utils/capitalize/capitalizeWord";
import dayjs from 'dayjs';
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat); // Enables parsing formatted strings

export default function Experience2({ nextStep, prevStep, workingThere }) {
  const profile = useSelector(e => e.profile);
  const dispatch = useDispatch();
  
  const exp = useSelector(exp => exp.activities);
  const currentExp = useSelector(exp => exp.currentExperience);
  const secret = useSelector(prev => prev.secret);
  const existing_cv_data = useSelector((prev) => prev.existingCV);
  const message = existing_cv_data.message;
  const profile1 = useSelector(e => e.login);
  const userInfo = useSelector(e => e.userInfo);

  const [startDate, setStartDate] = useState(dayjs());
  const [endDate, setEndDate] = useState(dayjs());
  const [isCurrentJob, setIsCurrentJob] = useState(false);
  const [error, setError] = useState('');
  const flowLanguage = useSelector(e => e.t_lang.selected);
  const sidebar = useSelector(e => e.sidebarOpen.message);

  // const handleNext = () => {
  //   if (!startDate || (!endDate && !isCurrentJob)) {
  //     setError('Please fill in all date fields before continuing');
  //     return;
  //   }
  //   setError('');
  //   nextStep();
  // };

  // **Function to Convert Formatted String Back to Dayjs**
  const parseFormattedDate = (dateString) => {
    return dateString ? dayjs(dateString, "MMM YYYY") : null;
  };

  useEffect(() => {
    if (currentExp.message !== null) {
      let start = parseFormattedDate(currentExp.message?.Work_start_date);
      let current_exp_end_date = workingThere == true ? null : parseFormattedDate(currentExp.message?.Work_end_date);
      setEndDate(current_exp_end_date !== undefined ? current_exp_end_date: "");
      setStartDate(start);
    } else {
      let cacheInfo = getOneFromServerCache("current_experience")
      cacheInfo.then(res => res.json())
        .then(res => {
          // console.log("server cache value", res);
          if (res.success === true) {
            if (res.data !== null && res.data !== undefined) {
              let resObj = JSON.parse(res.data);
              // console.log("respObj", resObj);
              dispatch(currentExperience(resObj));
              let start = parseFormattedDate(resObj.Work_start_date);
              let end =
                workingThere === true ? null : parseFormattedDate(resObj.Work_end_date);
  
              setStartDate(start);
              setEndDate(end);
            }
            // console.log("Done");
          } else if (res.success === false && res.message == "Unauthorized") {
            dispatch(returnHome(res.status));
          }
        }).catch (error => console.log("Error prefilling the current experience company name and title", error))
    }

  }, []);

  const [showStartDate, setShowStartDate] = useState(true);
  const [showEndDate, setShowEndDate] = useState(false);
  const [showButtomBTN, setShowButtomBTN] = useState(false);

  useEffect(() => {
    if (startDate !== null && workingThere == false) {
      // Show last name label and input once first name is being typed
      const showEndDateTimeout = setTimeout(() => setShowEndDate(true), 800);

      return () => clearTimeout(showEndDateTimeout);
    }
  }, [startDate]); // Runs only when firstName 
  
  useEffect(() => {
    // Show last name label and input once first name is being typed
    const showButtomBTNTimeout = setTimeout(() => setShowButtomBTN(true), 1000);

    return () => clearTimeout(showButtomBTNTimeout);
  }, []); // Runs only when firstName updates

    /* Moving section */
    const handlePrev = () => {
      prevStep();
    }
  
    const handleNextCall = async () => {
      // handleNext(dispatch, firstName, lastName, nextStep);
      try {
        if (startDate !== "" && endDate !== "") {
          let experience = {
            Where_i_worked: currentExp.message?.Where_i_worked,
            // Where_i_worked_location: $('[name="work_place"]').val(),
            My_job_title: currentExp.message?.My_job_title,
            Work_start_date: startDate.format("MMM YYYY"),
            Work_end_date: endDate ? endDate.format("MMM YYYY") : "Present", // Save formatted
            Day_to_day_work: currentExp.message?.Day_to_day_work || null,
            // Review: true,
            Tags: currentExp.message?.Tags || null
          }
          dispatch(currentExperience(experience));
          // save into server cache
          await saveIntoServerCache("current_experience", experience);
          nextStep();
        } else {
          setTimeout(() => {
              toast.error("A leas one job title is required", {
                position: toast.POSITION.TOP_RIGHT,
              });
          }, 50);
        }
      } catch (error) {
          throw error
      }
    }

  return (
    <div className="bg-[#FAFAFA] px-4 md:px-6 lg:px-8 xl:px-10 py-8 w-full overflow-y-scroll ScrollOnly h-calc-70 flex justify-center lg:items-center">
      <div className={`${sidebar ? "sm:max-w-[65vw]" : "sm:max-w-[80vw]"} vsm:w-[90vw] gap-y-16 h-max py-10 px-6 md:px-8 md:py-8  lg:gap-0 lg:h-full bg-white flex flex-col lg:justify-between rounded-lg shadow-md`}>

        <div className='flex justify-center w-full'>
          <div className="tabarea gap-x-4 items-center inline-flex flex-shrink-0 max-w-full overflow-hidden">
            <div className="vsm:hidden md:inline">
              <Tab
                label="Personal Information"
                current={false}
                completed={true}
                num="1"
              />
            </div>
            <Tab num="2" current={true} label="Experience" completed={false} />
            <Tab num="3" current={false} label="Skills" completed={false} />
            <Tab num="4" current={false} label="Education" completed={false} />
            <Tab num="5" current={false} label="Professional Summary" completed={false} />
          </div>
        </div>

        <div className='flex justify-center w-full'>
          <div className='flex flex-col gap-y-6 items-center w-full lg:max-w-[90%] justify-center'>
            {/* <div className="flex items-center gap-x-2 mb-2">
              <label className="text-black font-medium text-sm">
                <Typewriter words={["Is this your current job?"]} loop={1} typeSpeed={50} />
              </label>
              <input
                type="checkbox"
                checked={isCurrentJob}
                onChange={(e) => setIsCurrentJob(e.target.checked)}
                className="h-4 w-4 text-[#5843BD] focus:ring-[#5843BD] border-gray-300 rounded"
              />
            </div> */}
            <div className={`flex ${workingThere == true ? "lg:w-p[400px]" : "lg:w-full"} vsm:w-[400px] flex-col lg:flex-row md:gap-8 md:justify-between justify-center items-center`}>
              {showStartDate && (
                <motion.div 
                  initial={{ opacity: 0, y: 30 }} 
                  animate={{ opacity: 1, y: 0 }} 
                  transition={{ duration: 0.8, ease: "easeOut", delay: 0.3 }}
                  className="flex vsm:max-w-[300px] sm:w-full flex-col gap-y-2 vsm:my-6 md:my-0"
                >
                  <div className='flex justify-center vsm:max-w-[300px] sm:w-full'>
                    <div>
                      <label className="text-black font-medium text-sm mb-2 notranslate">
                        {flowLanguage == "Spanish" ? (
                          <Typewriter key={flowLanguage} words={["¿Cuándo comenzaste este empleo? (Mes y año)"]} loop={1} typeSpeed={40} />
                        ) : (
                          <Typewriter key={flowLanguage} words={["When did you start this job? (Month & Year)"]} loop={1} typeSpeed={40} />
                        )}
                        {/* <Typewriter words={["When did you start this job? (Month & Year)?"]} loop={1} typeSpeed={50} /> */}
                        </label>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={['DatePicker']}>
                          <DatePicker
                            views={['month', 'year']}
                            value={startDate}
                            onChange={(newValue) => setStartDate(newValue)}
                            className="w-full vsm:max-w-[300px] md:max-w-[300px]"
                          />
                        </DemoContainer>
                      </LocalizationProvider>
                    </div>
                  </div>
                </motion.div>
              )}

              { showEndDate && (
                <motion.div 
                  initial={{ opacity: 0, y: 30 }} 
                  animate={{ opacity: 1, y: 0 }} 
                  transition={{ duration: 0.8, ease: "easeOut", delay: 0.3 }}
                  className="flex vsm:max-w-[300px] sm:w-full flex-col gap-y-2"
                >
                  <div className='flex justify-center '>
                    <div>
                    {!isCurrentJob && <div className="flex w-full flex-col gap-y-2">
                        <label className="text-black font-medium text-sm notranslate">
                        {flowLanguage == "Spanish" ? (
                          <Typewriter key={flowLanguage} words={["¿Cuándo terminaste este empleo? (Mes y año)"]} loop={1} typeSpeed={40} />
                        ) : (
                          <Typewriter key={flowLanguage} words={["When did you end this job? (Month & Year)"]} loop={1} typeSpeed={40} />
                        )}
                        {/* <Typewriter words={["When did you end this job? (Month & Year)?"]} loop={1} typeSpeed={50} /> */}
                        </label>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DemoContainer components={['DatePicker']}>
                            <DatePicker
                              views={['month', 'year']}
                              value={endDate}
                              onChange={(newValue) => setEndDate(newValue)}
                              className="w-full max-w-[400px]"
                              minDate={startDate}
                            />
                          </DemoContainer>
                        </LocalizationProvider>
                        {error && <p className='text-xs text-[#FF6633] font-medium'>{error}</p>}
                      </div>
                    }
                    </div>
                  </div>
                </motion.div>
              )}
            </div>
          </div>
        </div>

        {/* Navigation Buttons */}
        <div className="flex justify-center w-full">
          {showButtomBTN && (
              <motion.div 
                initial={{ opacity: 0, y: 30 }} 
                animate={{ opacity: 1, y: 0 }} 
                transition={{ duration: 0.8, ease: "easeOut", delay: 0.4 }}
                className="flex justify-between lg:max-w-[90%] w-full">
                  <button
                    onClick={handlePrev}
                    className="border-[#FF6633] border flex items-center gap-x-3 text-black font-medium py-4  vsm:px-6 px-8 rounded-md "
                  >
                      <svg width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1.5 8.99891L9.5 16.3789" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M1.5 9L9.5 1.62" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                      <span className="notranslate" key={flowLanguage}>
                        {flowLanguage == "Spanish" ? (
                          "ANTERIOR"
                        ) : (
                          "PREVIOUS"
                        )}
                      </span>
                  </button>
                  
                  <button
                      onClick={handleNextCall}
                      className="bg-[#5843BD] flex items-center gap-x-3 text-white font-medium py-3  vsm:px-4  px-6 rounded-md"
                  >
                      <span className="notranslate" key={flowLanguage}>
                        {flowLanguage == "Spanish" ? (
                          "GUARDAR"
                        ) : (
                          "SAVE"
                        )}
                      </span>
                      <svg width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9.5 8.99891L1.5 16.3789" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M9.5 9L1.5 1.62" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                  </button>

              </motion.div>
            )}
          </div>
          
      </div>
      <ToastContainer />
    </div>
  );
}